var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"button text-transform-none",class:{
    'alsok-linkblue': _vm.buttonType === _vm.type1,
    'alsok-red': _vm.buttonType === _vm.type2,
    'alsok-lightgreen': _vm.buttonType === _vm.type3,
    'alsok-btngray': _vm.buttonType === _vm.type4,
    'button-size': _vm.buttonSize250 == true,
  },attrs:{"disabled":_vm.disableFlag},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []

export { render, staticRenderFns }